import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import deleteIcon from "../../assets/images/reservation-delete-icon.svg";
import arrowIcon from "../../assets/images/cancel-reservation-arrow-icon.svg";
import "../css/CancelReservationPopup.css";
import { STRING } from "utils/strings";
import { getCreditRefundDetail } from "utils/utils";
import { CALENDAR_RESERVATION_TABS } from "utils/constants";

interface CancelReservationPopupProps {
  open: boolean;
  reservationData: any;
  onClick: () => void;
  onClose: () => void;
}

const CancelReservationPopup: React.FC<CancelReservationPopupProps> = ({
  open,
  reservationData,
  onClick,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "cancel-reservation-popup-container",
      }}
      BackdropProps={{
        className: "cancel-reservation-popup-backdrop",
      }}
    >
      <DialogContent sx={{ padding: 0, margin: 0 }}>
        <div className="cancel-reservation-popup-header">
          {STRING.CANCEL_RESERVATION_POPUP_TITLE}
        </div>
        <div className="cancel-reservation-popup-divider"></div>
        <div className="cancel-reservation-popup-title">
          <span>
            We Will Miss You!{" "}
            <span style={{ color: "white" }}>
              In This{" "}
              {CALENDAR_RESERVATION_TABS.find(
                (type) => type.value === reservationData?.slot_service_type,
              )?.name || ""}
            </span>
          </span>
        </div>
        <div className="cancel-reservation-popup-title-container">
          <span>{reservationData?.slot_title}</span>
        </div>

        <div className="cancel-reservation-popup-containt-container">
          <span>Cancellation Policy :</span>
          <div className="detail-conatiner">
            {getCreditRefundDetail(reservationData?.slot_service_type).map(
              (data: any) => (
                <span>
                  ● {data?.title}: →{" "}
                  <span
                    style={{
                      color:
                        data?.subTitle === "0% Refund" ? "#c2b58c" : "#CDD7D6",
                    }}
                  >
                    {data?.subTitle}
                  </span>
                </span>
              ),
            )}
          </div>
        </div>
        <div className="cancel-reservation-popup-button-container">
          <div className="delete-container" onClick={onClick}>
            <img src={deleteIcon} alt="cancel-reservation-button" />
            Cancel
          </div>
          <div className="cancel-button" onClick={onClose}>
            <img src={arrowIcon} alt="arrow-icon" />I M Still In
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CancelReservationPopup;
